module.exports = require("@tiptap/core");